(() => {
// Motion is an enhancement: no content is hidden before JavaScript or while waiting to enter view.
const motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
const motionSeen = new WeakSet();
const motionActive = new Map();
let motionObserver;
const motionTargets = [
  '.sip-hero-copy > *', '.sip-hero-media',
  '.sip-section-head > *', '.sip-section-intro > *', '.sip-trust-row > *',
  '.sip-assortment-card', '.sip-product-card', '.sip-small-product',
  '.sip-reveal', '.sip-custom > div:first-child', '.sip-campaign',
  '.sip-about > div', '.sip-help-home-intro > *', '.sip-help-hero > *',
  '.sip-help-group-heading', '.sip-help-group-intro', '.sip-help-item',
  '.sip-help-card > *', '.sip-contact > div:first-child > *',
  '.sip-detail-copy > .sip-eyebrow', '.sip-detail-copy > h1',
  '.sip-detail-copy > .sip-lead', '.sip-detail-copy > .sip-facts',
  '.sip-gallery > img'
].join(',');

function finishMotion(element) {
  motionActive.get(element)?.finish();
}

function revealMotion(element) {
  motionObserver?.unobserve(element);
  if (motionSeen.has(element)) return;
  motionSeen.add(element);
  element.classList.add('sip-motion-entered', 'is-visible');
  if (motionPreference.matches || element.contains(document.activeElement)) return;

  const isImage = element.matches('.sip-hero-media, .sip-gallery > img');
  const isGraphic = element.matches('.sip-campaign');
  const isCard = element.matches('.sip-assortment-card, .sip-product-card, .sip-small-product, .sip-use');
  element.dataset.sipMotion = isImage ? 'image' : isGraphic ? 'graphic' : isCard ? 'card' : 'text';
  const siblingIndex = Array.from(element.parentElement.children).indexOf(element);
  const compact = window.matchMedia('(max-width: 800px)').matches;
  const delay = (siblingIndex % 3) * (compact ? 35 : 65);
  const distance = compact ? 12 : 20;
  const from = isImage
    ? { opacity: .55, transform: 'translateY(12px) scale(.985)' }
    : isGraphic
      ? { opacity: .45, transform: `translateY(${distance}px) scale(.985)` }
      : { opacity: .35, transform: `translateY(${distance}px)` };
  const animation = element.animate([from, { opacity: 1, transform: 'none' }], {
    duration: compact ? 500 : 650,
    delay,
    easing: 'cubic-bezier(.2,.7,.25,1)',
    fill: 'backwards'
  });
  motionActive.set(element, animation);
  const cleanUp = () => motionActive.delete(element);
  animation.addEventListener('finish', cleanUp, { once: true });
  animation.addEventListener('cancel', cleanUp, { once: true });
}

function initScrollMotion(root = document) {
  if (motionPreference.matches || !('IntersectionObserver' in window) || !Element.prototype.animate) return;
  if (!motionObserver) {
    motionObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) revealMotion(entry.target);
      });
    }, { threshold: .08, rootMargin: '0px 0px -24px 0px' });
  }
  root.querySelectorAll(motionTargets).forEach(element => {
    if (motionSeen.has(element) || element.classList.contains('sip-motion-ready')) return;
    element.classList.add('sip-motion-ready');
    motionObserver.observe(element);
  });
}

// A keyboard focus target and its surrounding card are always immediately settled.
document.addEventListener('focusin', event => {
  let element = event.target;
  while (element instanceof Element) {
    if (element.classList.contains('sip-motion-ready')) {
      motionSeen.add(element);
      motionObserver?.unobserve(element);
      element.classList.add('sip-motion-entered', 'is-visible');
      finishMotion(element);
    }
    element = element.parentElement;
  }
});
motionPreference.addEventListener('change', event => {
  if (event.matches) {
    motionObserver?.disconnect();
    motionActive.forEach(animation => animation.finish());
    document.querySelectorAll('.sip-motion-ready').forEach(element => {
      element.classList.remove('sip-motion-ready');
    });
  } else {
    initScrollMotion();
  }
});
function init(root=document) {
  root.querySelectorAll('.sip-menu-toggle').forEach(button=>{if(button.dataset.ready)return;button.dataset.ready='1';const nav=document.getElementById(button.getAttribute('aria-controls'));button.addEventListener('click',()=>{const open=button.getAttribute('aria-expanded')!=='true';button.setAttribute('aria-expanded',String(open));nav.classList.toggle('is-open',open)});nav.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{button.setAttribute('aria-expanded','false');nav.classList.remove('is-open')}));document.addEventListener('keydown',e=>{if(e.key==='Escape'&&button.getAttribute('aria-expanded')==='true'){button.setAttribute('aria-expanded','false');nav.classList.remove('is-open');button.focus()}})});
  root.querySelectorAll('[data-motion-wrap]').forEach(wrap=>{const button=wrap.querySelector('[data-animation]'),img=wrap.querySelector('img');if(!button||!img||button.dataset.ready)return;button.dataset.ready='1';const original={src:img.src,srcset:img.getAttribute('srcset'),sizes:img.getAttribute('sizes')};const stop=()=>{img.src=original.src;if(original.srcset)img.setAttribute('srcset',original.srcset);if(original.sizes)img.setAttribute('sizes',original.sizes);button.setAttribute('aria-pressed','false');button.querySelector('[data-play-label]').hidden=false;button.querySelector('[data-stop-label]').hidden=true};button.addEventListener('click',()=>{if(button.getAttribute('aria-pressed')==='true'){stop();return}img.removeAttribute('srcset');img.removeAttribute('sizes');img.src=button.dataset.animation;button.setAttribute('aria-pressed','true');button.querySelector('[data-play-label]').hidden=true;button.querySelector('[data-stop-label]').hidden=false});document.addEventListener('visibilitychange',()=>{if(document.hidden)stop()});if('IntersectionObserver'in window){new IntersectionObserver(entries=>{if(!entries[0].isIntersecting&&button.getAttribute('aria-pressed')==='true')stop()}).observe(wrap)}});
  root.querySelectorAll('[data-color]').forEach(button=>{if(button.dataset.ready)return;button.dataset.ready='1';button.addEventListener('click',()=>{const area=button.closest('.sip-custom');area.querySelector('.sip-campaign').style.setProperty('--campaign',button.dataset.color);area.querySelectorAll('[data-color]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)))})});
  root.querySelectorAll('[data-city-input]').forEach(input=>{if(input.dataset.ready)return;input.dataset.ready='1';const out=input.closest('.sip-custom').querySelector('[data-city-output]'),original=out.textContent;input.addEventListener('input',()=>{out.textContent=input.value.trim()||original})});
  root.querySelectorAll('[data-use]').forEach(link=>{if(link.dataset.ready)return;link.dataset.ready='1';link.addEventListener('click',()=>{const field=document.querySelector('[data-use-field]');if(field)field.value=link.dataset.use})});
  const field=root.querySelector('[data-product-field]');const product=new URLSearchParams(location.search).get('produkt');if(field&&product){if(!Array.from(field.options).some(o=>o.value===product))field.add(new Option(product,product));field.value=product}
  initScrollMotion(root);
}
init();document.addEventListener('shopify:section:load',e=>init(e.target));
})();
